export default __webpack_public_path__ + "static/media/38.d6710fb1.png";